import { gql, useMutation } from '@apollo/client';
import { GET_DOCUMENT_IMPORTER__BY_ID } from './get-document-importer-by-id.hook';
import { GET_DOCUMENTS_IMPORTER } from './get-documents-importer.hook';

export const CREATE_DOCUMENT_IMPORTER_ITEMS = gql`
  mutation uploadDocumentImporterFiles($payload: CreateDocumentImporterItemsInput!) {
    uploadDocumentImporterFiles(payload: $payload) {
      _id
      companyId
    }
  }
`;

export const useUploadDocumentImporterFiles = () => {
  const [uploadDocumentImporterFiles, { loading }] = useMutation(CREATE_DOCUMENT_IMPORTER_ITEMS, {
    refetchQueries: [GET_DOCUMENT_IMPORTER__BY_ID, GET_DOCUMENTS_IMPORTER],
  });
  return { uploadDocumentImporterFiles, loading };
};
